import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { authGuard } from "./guards/auth.guard";
import { loginGuard } from "./guards/login.guard";
import { onboardingGuard } from "./guards/onboarding.guard";
import { NotFoundComponent } from "./not-found/not-found.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { VerifyEmailResolver } from "./resolvers/verify-email.resolver";
import { TermsOfServiceComponent } from "./terms-of-service/terms-of-service.component";

const routes: Routes = [
  {
    path: "",
    canActivate: [authGuard, onboardingGuard],
    loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardModule)
  },

  {
    path: "register",
    canActivate: [loginGuard],
    loadChildren: () => import("./register/register.module").then((m) => m.RegisterModule)
  },
  {
    path: "login",
    canActivate: [loginGuard],
    loadComponent: () => import("./login/login.component").then((m) => m.LoginComponent)
  },
  {
    path: "reset",
    canActivate: [loginGuard],
    loadComponent: () =>
      import("./password-reset/password-reset.component").then((m) => m.PasswordResetComponent)
  },
  {
    path: "reset-password/:token",
    loadComponent: () =>
      import("./reset-password/reset-password.component").then((m) => m.ResetPasswordComponent),
    canActivate: [loginGuard]
  },
  {
    path: "confirm/:token",
    resolve: { data: VerifyEmailResolver },
    loadComponent: () => import("./login/login.component").then((m) => m.LoginComponent),
    canActivate: [loginGuard]
  },
  {
    path: "onboarding",
    canActivate: [authGuard],
    loadChildren: () => import("./onboarding/onboarding.module").then((m) => m.OnboardingModule)
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent
  },
  {
    path: "terms-of-service",
    component: TermsOfServiceComponent
  },
  { path: "error/404", component: NotFoundComponent },
  {
    path: "**",
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
